import React from 'react';

import { BaseCrud, FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { TextField } from 'react/components/fields';

const BankCrud = (props) => (
  <BaseCrud updateMethod="PATCH" tabName="Bank.title" {...props}>
    <FormSection title="Bank.section.general.title">
      <FormSectionColumn>
        <TextField
          label="Bank.field.key"
          name="key"
          required
        />
        <TextField
          label="Bank.field.description"
          name="description"
          required
        />
      </FormSectionColumn>
    </FormSection>
  </BaseCrud>
);

export default BankCrud;
